import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Archive from './archive/Archive';
import CommonTabs, { TABS_APPEARANCE } from '../../../components/common-tabs/CommonTabs';
import CommonTabPanel from '../../../components/common-tabs/CommonTabPanel';
import { resetActiv8SettingsData } from '../../../redux/settings/activ8/activ8SettingsReducer';
import { ACTIV8_SETTINGS_TABS } from '../../../constants';

function Activ8Settings() {
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState(ACTIV8_SETTINGS_TABS.ARCHIVE);

  const TABS = useMemo(
    () => [
      {
        label: t('archive'),
      },
    ],
    [t],
  );

  const handleChangeTabs = (_, newTab) => {
    setSelectedTab(newTab);
  };

  useEffect(() => {
    return () => {
      dispatch(resetActiv8SettingsData());
    };
  }, [dispatch]);

  return (
    <div>
      <CommonTabs
        tabs={TABS}
        value={selectedTab}
        onChange={handleChangeTabs}
        isContainerFullWidth={false}
        appearance={TABS_APPEARANCE.FILLED}
      />

      <CommonTabPanel value={selectedTab} index={ACTIV8_SETTINGS_TABS.ARCHIVE}>
        <Archive />
      </CommonTabPanel>
    </div>
  );
}

export default Activ8Settings;
